import { useState, useEffect } from 'react'
import { productTypesEndpoint } from '../config.json'
import axios from 'axios'

export default function getResinousData(resinousFloorSystemsData, resinousWallSystemsData, resinousCoveSystemsData) {
    const [productTypes, setProductTypes] = useState()
    let bu = 1;
    let urlPath = window.location.href.toLowerCase();

    if (urlPath.indexOf("eu.") > -1 || urlPath.indexOf("europeauthor") > -1 || urlPath.indexOf("sc_site=europe") > -1) {
        bu = 6;
    }
    if (urlPath.indexOf("au.") > -1 || urlPath.indexOf("australiaauthor") > -1 || urlPath.indexOf("sc_site=australia") > -1) {
        bu = 3;
    }

   useEffect(() => {
      // Get productTypes data
       axios.get(`${productTypesEndpoint}/${bu}/en`)
      .then(res => {
         setProductTypes(res.data)
      })
   }, [])

   const resinousFloorSystems = []
   resinousFloorSystemsData.map(rfs => {
      return(
         resinousFloorSystems.push({
         id: rfs.mainSystemId,
         name: rfs.name,
         subheading: rfs.subheading,
         description: rfs.shortDescription,
         url: rfs.detailPage,
         category: rfs.category,
         image: rfs.systemImage
         })
      )
   })
   const resinousWallSystems = []
   resinousWallSystemsData.map(rws => {
      return(
         resinousWallSystems.push({
         id: rws.mainSystemId,
         name: rws.name,
         subheading: rws.subheading,
         description: rws.shortDescription,
         url: rws.detailPage,
         category: rws.category,
         image: rws.systemImage
         })
      )
   })
   const resinousCoveSystems = []
   resinousCoveSystemsData.map(rcs => {
      return(
         resinousCoveSystems.push({
         id: rcs.mainSystemId,
         name: rcs.name,
         subheading: rcs.subheading,
         description: rcs.shortDescription,
         url: rcs.detailPage,
         category: rcs.category,
         image: rcs.systemImage
         })
      )
   })
   return {
      productTypes,
      resinousFloorSystems,
      resinousWallSystems,
      resinousCoveSystems
   }
}


// WEBPACK FOOTER //
// ./src/services/resinousData.js